export default "__VITE_PUBLIC_ASSET__914e99b8__"